import * as z from "zod";

export const LayerDtoSchema = z
    .object({
        url: z.string().trim(),
    })
    .readonly();
export type LayerDto = z.output<typeof LayerDtoSchema>;

export type LayerCreateBody = Record<
    string,
    {
        layer: string;
        weeks_ago: number;
    }
>;
